import Select from "react-select";
import { TbReportSearch } from "react-icons/tb";
import { useState } from "react";
export default function FilterSupplierProduct({
  productList,
  supplierList,
  pageDebounce,
  filterData,
  filterDataHandler,
  supplierProductFilter,
  setUpdater,
}) {
  return (
    <div className="d-flex flex-wrap align-items-center my-4 ">
      <div className=" col-sm-10 col-12 ms-1 my-1">
        <label>انتخاب محصول</label>{" "}
        <Select
          options={productList}
          isMulti={true}
          value={filterData.product}
          onChange={(e) => {
            filterDataHandler({ product: e });
          }}
          onInputChange={(value) => {
            pageDebounce(value);
          }}
        />
      </div>
      <div className=" col-sm-10 col-12 ms-1 my-1">
        <label>انتخاب فروشگاه</label>{" "}
        <Select
          options={supplierList}
          isMulti={true}
          onChange={(e) => {
            filterDataHandler({ supplier: e });
          }}
          value={filterData.supplier}
        />
      </div>
      <div className="d-flex col-12">
        {" "}
        <button
          className="btn text-light bg-danger align-self-end ms-auto my-1 "
          onClick={() => {
            filterDataHandler({ product: [], supplier: [] });
            setUpdater((prev) => !prev);
          }}
        >
          <TbReportSearch color="white" /> حذف فیلتر
        </button>
        <button
          className="btn text-light bg-success align-self-end ms-1 my-1"
          onClick={() => {
            supplierProductFilter(
              filterData.product.map((val) => val.value),
              filterData.supplier.map((val) => val.value)
            );
          }}
        >
          <TbReportSearch color="white" /> فیلتر
        </button>
      </div>
    </div>
  );
}
